import styled, { css } from 'styled-components';
import { clickableMixin } from '../../theme/utils';
import { themeColor } from '../../theme/colors';
import { smBold, xxxsRegular, xxxxsRegular } from '../../theme/typography';

export const Container = styled.div`
  display: inline-block;
  position: relative;
`;

export const GroupRect = styled.rect<{ weight: number }>`
  stroke: ${themeColor({ dark: 'turquoiseQuinary', light: 'strokeSecondary' })};
  ${(props) =>
    props.theme.name === 'dark'
      ? css`
          fill: rgba(15, 254, 230, ${Math.max(props.weight, 0.05)});
        `
      : css`
          fill: rgba(11, 177, 161, ${Math.max(props.weight, 0.05)});
        `}

  /* clickableMixin if onClick is present */
  ${({ onClick }) =>
    onClick &&
    css`
      ${clickableMixin}
    `}

  &:hover {
    stroke: rgba(15, 254, 230, 1);
  }
`;

export const GroupText = styled.text<{ weight: number }>`
  ${xxxsRegular}
  text-anchor: start;
  fill: ${(props) =>
    props.weight > 0.5
      ? themeColor({ dark: 'black', light: 'white' })
      : themeColor({ dark: 'white', light: 'black' })};
`;

export const LeafBackgroundRect = styled.rect<{ weight: number }>`
  ${(props) =>
    props.weight === 0
      ? css`
    fill ${themeColor('black')};
    `
      : css`
          fill: ${themeColor({ light: 'turquoise', dark: 'black' })};
        `}
`;

export const LeafRect = styled.rect<{ weight: number }>`
  ${clickableMixin}

  ${(props) =>
    props.theme.name === 'dark'
      ? css`
          fill: rgba(15, 254, 230, ${Math.max(props.weight, 0.05)});
        `
      : props.weight !== 0 &&
        css`
          fill: rgba(255, 255, 255, ${1 - props.weight});
        `}
    &:hover {
    stroke: rgba(15, 254, 230, 1);
  }
`;

export const LeafText = styled.text<{ weight: number; centered?: boolean }>`
  ${xxxxsRegular}
  text-anchor: start;
  fill: ${(props) =>
    props.weight > 0.5 ? 'black' : themeColor('textTertiary')};
  pointer-events: none;

  ${({ centered }) =>
    centered &&
    css`
      text-anchor: middle;
      alignment-baseline: middle;
    `};
`;

export const Tooltip = styled.div`
  border-radius: 6px;
  background: #202224;
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.04);

  padding: 12px;
  position: absolute;
  z-index: 100;

  min-width: 200px;

  pointer-events: none;
  transform: translateX(-50%) translateY(-110%);

  transition: top 200ms;

  display: none;
`;

export const DefaultTooltip = styled.div`
  ${smBold};
  color: ${themeColor('white')};
  text-align: center;
`;
